import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";

type Tables = Array<[number, Array<[string, number | undefined]>]>;

export default function ExpectedUnexpectednessTables({
  tables: _,
}: {
  tables: { loot: Tables };
}) {
  const s2Tables: any = [
    [0.36, [["FourCostUnit"], ["FourCostUnit"]]],
    [0.32, [["Gold", 2], ["TFT_ArmoryKeyCompleted"], ["REFORGER", 3]]],
    [0.25, [["Gold", 11]]],
    [0.04, [["Gold", 2], ["TFT_Consumable_MasterworkUpgrade"]]],
    [0.03, [["Gold", 5], ["TACTICIANSCROWN"]]],
  ];
  const s3Tables: any = [
    [0.36, [["Gold", 10], ["LesserDuplicator"], ["LesserDuplicator"]]],
    [0.32, [["Gold", 2], ["TFT_ArmoryKeyOrnn"]]],
    [0.25, [["Gold", 15]]],
    [
      0.04,
      [
        ["Gold", 2],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
      ],
    ],
    [0.03, [["Gold", 5], ["EMBLEM_SET14"], ["EMBLEM_SET14"]]],
  ];
  const s4Tables: any = [
    [0.36, [["FiveCostUnit"], ["FiveCostUnit"], ["FiveCostUnit"]]],
    [0.32, [["Gold", 2], ["TFT_ArmoryKeySupport"]]],
    [0.25, [["Gold", 20]]],
    [
      0.04,
      [
        ["Gold", 2],
        ["COMPLETEDITEMS"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
      ],
    ],
    [0.03, [["Gold", 5], ["FiveCostUnit"], ["FiveCostUnit"], ["Duplicator"]]],
  ];

  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"Expected Unexpectedness"} />
        <h2 className="h2 p-4 pb-8 flex items-center gap-1">
          {T.augments("ExpectedUnexpectedness")}
        </h2>
        <div>
          <h3 className="pt-12 px-4 pb-5 h4 leading-tight">{`Stage 2`}</h3>
          <LootGrid data={s2Tables} />
        </div>
        <div>
          <h3 className="pt-12 px-4 pb-5 h4 leading-tight">{`Stage 3`}</h3>
          <LootGrid data={s3Tables} />
        </div>
        <div>
          <h3 className="pt-12 px-4 pb-5 h4 leading-tight">{`Stage 4`}</h3>
          <LootGrid data={s4Tables} />
        </div>
      </div>
    </AdLayout>
  );
}
